import Axios from '../context/axios/AxiosControl'

export const getMenus = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'MENU_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/menu/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MENU_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'MENU_NOT_LOADING'
        })
    }
}

export const getMenu = (menu) => async (dispatch) => {
    dispatch({
        type: 'MENU_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/menu/get/'+ menu, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'MENU_GET_SUCCESS',
                payload: data.menu
            })
        }
    } catch (error) {
        dispatch({
            type: 'MENU_NOT_LOADING'
        })
    }
}

export const addMenu = (menudata) => async (dispatch) => {
    dispatch({
        type: 'MENU_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/restaurant/menu/register', menudata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'MENU_ADD_SUCCESS',
                payload: data
            })
        }
        if (status === 264) {
            dispatch({
                type: 'MENU_ADD_DUPLICATED',
                payload: data
            })
        }
        dispatch({
            type: 'MENU_RESET_RESULT'
        })
    } catch (error) {
        dispatch({
            type: 'MENU_NOT_LOADING'
        })
    }
}

export const editMenu = (menudata, idMenu) => async (dispatch) => {
    dispatch({
        type: 'MENU_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/menu/edit/' + idMenu, menudata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'MENU_EDIT_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'MENU_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MENU_ERROR'
        })
    }
}

export const deleteMenu = (idMenu) => async (dispatch) => {
    dispatch({
        type: 'MENU_LOADING'
    })
    try {
        const { data, status} = await Axios.delete('/api/restaurant/menu/remove/' + idMenu, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 265 || status === 260) {
            dispatch({
                type: 'MENU_DELETE_SUCCESS',
                payload: data.message,

            })
            dispatch({
                type: 'MENU_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'MENU_ERROR'
        })
    }
}